import { Flex } from 'antd'
import { useMemo } from 'react'
import { AppSessionType } from '~/features/appSession/common'
import { useLogic } from '../hooks/useLogic'
import { useSteps } from '../hooks/useSteps'
import { OnboardingStepOption } from '../types'
import { Stepper } from './Stepper'

type Props<Type> = {
  appSession: AppSessionType
  valuesDefault: Partial<Type>
  steps: OnboardingStepOption<Type>[]
  onSubmitted: () => void
}

export const Wrapper = <Type,>({
  appSession,
  valuesDefault,
  steps: _steps = [],
  onSubmitted,
}: Props<Type>) => {
  const logic = useLogic({ appSession, valuesDefault, onSubmit: onSubmitted })

  const { steps } = useSteps({ values: logic.values, options: _steps })

  const countSteps = steps.length

  const step = useMemo(() => {
    return steps[logic.index]
  }, [logic.index, steps])

  const isLast = logic.index === steps.length - 1
  const isFirst = logic.index === 0

  return (
    <Flex className="w-full h-full" vertical>
      <Stepper
        count={countSteps}
        index={logic.index}
        className="mb-4"
        style={{ position: 'sticky', top: 0, zIndex: 3 }}
      />

      {step.content({
        ...logic.step,
        onNext: isLast ? () => {} : logic.next,
        onBack: isFirst ? undefined : logic.back,
        onSave: values =>
          isLast
            ? logic.submit(values, step.key)
            : logic.save(values, step.key),
        isSubmit: isLast,
      })}
    </Flex>
  )
}
